<template>
  <v-container fluid>
    <v-card>
      <v-toolbar>
        <v-icon>cloud_download</v-icon>
        <v-toolbar-title class="font-weight-light"
          >&nbsp;Reporte De Tarjetas Vencidas</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              color="red"
              v-on="on"
              @click="setStatusTareaFrecuente(action)"
            >
              <v-icon v-if="action.esFrecuente">favorite</v-icon>
              <v-icon v-else>favorite_border</v-icon>
            </v-btn>
          </template>
          <span v-if="action.esFrecuente">Quitar de Tareas Frecuentes</span>
          <span v-else>Agregar a Tareas Frecuentes</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text>
        
        <v-divider></v-divider>
        <v-row dense> </v-row>
      </v-card-text>
      <v-card-actions>
        <!-- <v-btn dark  color="green" @click="procesarBase">
                    Descargar Archivo&nbsp;
                    <v-icon >cloud_download</v-icon>                  
                </v-btn> -->
        <v-spacer></v-spacer>
        <v-btn dark color="green" @click="procesarReporte">
          Generar Reporte&nbsp;
        </v-btn>
      </v-card-actions>
    </v-card>

    <app-loading :loading="loading"></app-loading>
  </v-container>
</template>
<script>
import { http } from "@/axios";
import Vue from "vue";
import {
  //mapState,
  mapGetters,
  mapMutations,
  mapActions,
} from "vuex";

export default {
  data() {
    return {
      loading: false,
      filtro: {
        fechaDesde: null,
        fechaHasta: null,
      },

    };
  },
  async created() {

    this.filtro.fechaDesde = this.$moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.filtro.fechaHasta = this.$moment(new Date()).format("YYYY-MM-DD");
  },
  computed: {
    ...mapGetters([
      "activeTask",
      "getActionFromLink",
      "user",
      "closeRelatedTasks",
    ]),
    action: function () {
      return this.getActionFromLink(this.$route.path);
    },
  },
  methods: {
    ...mapMutations([
      "setActiveTask",
      "alertClear",
      "alertSuccess",
      "alertWarning",
      "alertError",
      "setReporteActivo",
    ]),
    ...mapActions(["setStatusTareaFrecuente"]),

    validar() {
      return true;
    },
    async procesarReporte() {
      // validaciones
      //console.group("ProcesarReporte");
      //console.log(this.filtro.estadoBCRA.value);
      //console.groupEnd();
      if (!this.validar()) {
        return;
      }

      var self = this;

      try {
        self.loading = true;

        let params = [];
        params.push({
          
        });

        this.setReporteActivo({
          reporte: "Reporte Tarjetas Vencidas.trdp",
          params: params,
        });
        window.open("/report-viewer");
      } catch (error) {
        // Error
        self.alertError(error);
      }
      self.loading = false;
    },
  },
};
</script>